import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

type ReceptionServicePractitionerDisplayNameCellProps = InteractiveTableCellProps<string | null>;

export const ReceptionServicePractitionerDisplayNameCell = (
   props: ReceptionServicePractitionerDisplayNameCellProps
): JSX.Element => {
   return (
      <InteractiveTable.TextViewCell
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
      />
   );
};
